const DATE_REGEX = {
	iso8601: /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})-\d{1,2}:\d{2}$/,
	brazilian: /^(\d{2})\/(\d{2})\/(\d{4})T(\d{2}):(\d{2})(?::(\d{2}))?-\d{1,2}:\d{2}$/,
	timeOnly: /\d{2}:\d{2}:00$/,
};

export {DATE_REGEX};
